<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gGXXya/tc-custom/9780795351013.jpg?1702065251192" alt="This image is the cover for the book Thrill of the Grass"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Thrill of the Grass
      </h1>
      <p class="bookDescription body article font2">
        <b>From the author of <i>Shoeless Joe</i>—the basis for the film <i>Field of Dreams</i>—come baseball stories that capture the magic and wonder of the game.</b><br/>  <br/> No one can write about baseball with the same brilliant combination of mysticism and realism as W. P. Kinsella. Lovers of the game and lovers of fine writing will thrill at the range and depth of the eleven stories that make up this collection.<br/>  <br/> From the magical conspiracy of the title story, to the celestial prediction in “The Last Pennant Before Armageddon,” to the desolation of “The Baseball Spur,” Kinsella explores the world of baseball and makes it, miraculously, a microcosm of the human condition.<br/>  <br/><b>Praise for W. P. Kinsella’s <i>The Dixon Cornbelt League and Other Baseball Stories</i></b><br/> “[Kinsella] defines a world in which magic and reality combine to make us laugh and think about the perceptions we take for granted.” —<i>The New York Times</i><br/>  <br/> “His short stories about baseball are wistful things of beauty which serve to remind us how the game should feel—the innate glory of a diamond etched in the minds of Americans.” —<i>Calgary Sun</i><br/>  <br/> “[Kinsella] uses baseball . . . As a familiar starting place for exploring, with pinpoint control, the human psyche.” —<i>Booklist</i><br/>  <br/> “Stories that read like lightning and tantalize the reader with fascinating scenarios.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        W. P. Kinsella
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?05c7371e